module.exports={moduleName:'react-native-restart-mock',Restart:()=>null,Platform:{OS:'web'}};